export default __webpack_public_path__ + "static/media/tnote2.9ea511ad.jpg";